import { useEffect, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import "react-dates/lib/css/_datepicker.css";
import "../../styles/style.css";
import "../../styles/payout.css";
import "../../styles/upi-mandate.css";
import {
  complaintAddComment,
  getComplaintsList,
  UpdateComment,
} from "../../action/complaints";
import { Loader } from "../loader";
import { Link } from "react-router-dom";
import moment from "moment";
import Pagination from "../pagination/paginationView";
import { Modal } from "react-bootstrap";

const RejectedRequest = () => {
  const [curPendingData, setCurPendingData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState("");
  const [showImage, setShowImage] = useState(null);
  const [loading, setLoading] = useState(true);

  const getCompletedRequest = async () => {
    setLoading(true);
    const response = await getComplaintsList(pageSize, pageNo, "REJECT");
    if (response.status) {
      setCurPendingData(response?.data?.list);
      setTotalCount(response.data.count);
      setLoading(false);
    }
  };
  useEffect(() => {
    getCompletedRequest();
  }, [pageNo, pageSize]);

  return (
    <div className="payout_data-content" style={{ height: "100%" }}>
      <div className="payout_data-head">
        <div className="payout_data-head-top mb-2">
          <div className="payout_data-left">
            <div className="payout_data_ttl">
              {" "}
              <Breadcrumb
                paths={[{ name: "Complaints" }, { name: "Rejected" }]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="tab_box">
        <div className="table-responsive">
          <table className="payout_table upi-mandate_table">
            <thead>
              <tr className="tableHead">
                <th className="thHeader">
                  <div className="payoutHead hndIcon">Ticket ID</div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead hndIcon">Department</div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead hndIcon">Complaint Title</div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead hndIcon">Complaint Count</div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead hndIcon">Created Date</div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead hndIcon">Attachment</div>
                </th>

                <th className="thHeader">
                  <div className="payoutHead hndIcon">Remarks</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10">
                    <Loader />
                  </td>
                </tr>
              ) : (
                <>
                  {curPendingData?.length > 0 ? (
                    curPendingData?.map((item) => {
                      return (
                        <tr key={item._id}>
                          <td>{item?.ticket}</td>
                          <td>{item?.departmentDetails?.name}</td>
                          <td>{item?.feed?.title || "-"}</td>
                          <td>
                            {item?.totalComplains ? (
                              <Link to={`/complaint/history/${item._id}`}>
                                {item.totalComplains}
                              </Link>
                            ) : (
                              "0"
                            )}
                          </td>
                          <td>
                            {item?.createdAt
                              ? moment(item.createdAt).format("DD MMM YYYY")
                              : "-"}
                          </td>
                          {/* <td>
                            {item?.complaints?.length
                              ? item?.complaints.map((el, i) => {
                                return (
                                  <div key={`attach-${i}`}>
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                      }}
                                      onClick={() =>
                                        setShowImage(
                                          process.env.REACT_APP_S3_URL +
                                          "/" +
                                          el.image
                                        )
                                      }
                                    >
                                      File {i + 1}
                                    </span>
                                  </div>
                                );
                              })
                              : ""}
                          </td> */}
                          <td>
                            <span
                              style={{
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                              onClick={() =>
                                setShowImage(
                                  process.env.REACT_APP_S3_URL +
                                  "/" +
                                  item?.image
                                )
                              }
                            >
                              File
                            </span>
                          </td>
                          <td>{item.remark}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10" className="text_center">
                        No data available
                      </td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
        {curPendingData.length > 0 ? (
          <Pagination
            currentPage={pageNo}
            totalCount={totalCount}
            pageSize={pageSize}
            onPageChange={(page) => setPageNo(page)}
            changePageSize={(page) => {
              setPageSize(page);
              setPageNo(1);
            }}
          />
        ) : (
          <></>
        )}
        <Modal show={showImage} centered onHide={() => setShowImage(null)}>
          <Modal.Body>
            <div style={{ maxHeight: "60vh", overflow: "hidden" }}>
              <img src={showImage} alt="Attachment" />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-dark" onClick={() => setShowImage(null)}>
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};
export default RejectedRequest;
